import React, { useEffect, useState, useRef, useMemo } from "react"
import './Cliente.css'
import SweetAlert from "sweetalert2"
import api from "../../../services/api"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import ContentHeader from "../../../components/ContentHeader"
import Content from "../../../components/Content"
import CardHeader from "../../../components/CardHeader"
import TableGrid from "../../../components/TableGrid"
import CardFooter from "../../../components/CardFooter"
import Button from "../../../components/Button"
import CustomModal from "../../../components/Modal"
import MUIDataTable from "mui-datatables"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { AiOutlineSearch } from 'react-icons/ai'
import moment from "moment"

import {
  ajustaActiveClassMenu,
  searchByAllKeys,
  decrypt,
  formatCnpjCpf,
  formatTypeMoviment,
  formatInstituition
} from "../../../util/rotinas"

import dayjs from 'dayjs'
import ptBr from 'dayjs/locale/pt-br'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { CustomToolbar } from "./CustomToolbar";
dayjs.locale(ptBr)
dayjs.extend(LocalizedFormat)


export default function Cliente() {
  const [loading, setLoading] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [isModalOpen, setModalStatus] = useState(false)

  const [clienteEscolhido, setClienteEscolhido] = useState([])
  const [listValoresRepasse, setListValoresRepasse] = useState([])

  const [listClientes, setListClientes] = useState([])
  const [listClienteFiltrado, setListClienteFiltrado] = useState([])

  const [enableSendFee, setEnableSendFee] = useState(false)

  const history = useHistory()
  const modalRef = useRef(null)
  const searchRef = useRef(null)

  //Acessos
  const [btnNovoCliente, setBtnNovoCliente] = useState(false)
  const [btnEditarCliente, setBtnEditarCliente] = useState(false)
  const [btnExcluirCliente, setBtnExcluirCliente] = useState(false)
  const [instituitions, setInstitutions] = useState([])
  const [moviments, setMoviments] = useState([])
  const [movimentsFiltered, setMovimentsFiltered] = useState([])
  const [modalMovimentShow, setModalMovimentShow] = useState(false)
  const [dataAtual, setDataAtual] = useState(undefined)
  const [form, setForm] = useState({
    type: "SALE"
  })

  const [taxMinCurrent, setTaxMinCurrent] = useState(0)

  function handleInputInstituition(key, value) {
    const t = instituitions.find(item => item.id === value)
    let tax = t.InstituitionFeeHistory.length === 1 ? Number(t.InstituitionFeeHistory[0].fee_value) : (0.25)
    setTaxMinCurrent(tax)
    handleForm(key, value)
  }

  function handleForm(key, value) {
    setForm({
      ...form,
      [key]: value
    })
  }

  async function getClientes() {
    setLoading(true)
    await api.get(`customer`).then((res) => {
      setListClientes(res.data.data)
      setListClienteFiltrado(res.data.data)
    })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function buildOptionsInstituition() {
    if (instituitions) {
      return instituitions.filter(item => item.active).map(i => {
        return <option key={i.id} value={i.id}>{i.name}</option>
      })
    }
  }


  function buildOptionsTypeMoviments() {
    const movimentTypes = [
      { name: "VENDA", value: "SALE" },
      { name: "DEVOLUÇÃO", value: "DEVOLUTION" },
      { name: "CASHOUT", value: "CASHOUT" }
    ]
    // handleForm('type', "SALE")
    return movimentTypes.map(i => {
      return <option key={i.value} value={i.value}>{i.name}</option>
    })

  }

  useEffect(() => {
    if (dataAtual === undefined) {
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = ano + '-' + mes + '-' + dia
      setDataAtual(dataAtual)
    }
  }, [dataAtual])

  useEffect(() => {
    ajustaActiveClassMenu("cadMenu", "cliMenu")

    const u = decrypt(localStorage.getItem("@ipm:user"), true)
    const acessos = u?.profile?.access

    let aList
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "customer" &&
        a.action === "new" &&
        a.has_access
    )
    if (aList.length !== 0) setBtnNovoCliente(true)
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "customer" &&
        a.action === "edit" &&
        a.has_access
    )
    if (aList.length !== 0) setBtnEditarCliente(true)
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "customer" &&
        a.action === "delete" &&
        a.has_access
    )
    if (aList.length !== 0) setBtnExcluirCliente(true)

    getClientes()
  }, [])

  const deleteCliente = function (obj) {
    SweetAlert.fire({
      title: "Confirma exclusão do cliente ?",
      text: `${obj?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api.delete(`/customer/${obj.id}`).then(() => {
          toast.success(`Registro excluído com sucesso.`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
          })
          getClientes()
        })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  async function getInstituitions() {
    api.get('instituition').then(res => {
      const data = res.data.data.filter(item => item.active === true)
      let tax = data[0].InstituitionFeeHistory.length === 1 ? Number(data[0].InstituitionFeeHistory[0].fee_value) : 0
      setInstitutions(data)
      setTaxMinCurrent(tax)
      handleForm('instituition_id', data[0].id)
    })
  }

  async function getClienteByCnpj(cnpj) {
    await api.get(`/customer/findByCnpj?cnpj=${cnpj}`).then((res) => {
      const actives = res.data.data.fees.filter(item => item.active === true).sort(comparar)
      const inactives = res.data.data.fees.filter(item => item.active === false).sort(comparar)
      const all = actives.concat(inactives);
      const allFormated = all.map(item => {
        if (item.type === 'SALE') {
          return {
            ...item,
            type: "VENDA"
          }
        } else if (item.type === "DEVOLUTION") {
          return {
            ...item,
            type: "DEVOLUÇÃO"
          }
        } else {
          return {
            ...item,
            type: "CASHOUT"
          }
        }
      })

      setListValoresRepasse(allFormated)
      setEnableSendFee(true)
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      setLoadingModal(false)
    })
  }

  async function showModalVlrRepasse(cliente) {
    setLoadingModal(true)
    setModalStatus(true)
    setClienteEscolhido(cliente)
    getClienteByCnpj(cliente.cpf_cnpj)
    getInstituitions()
  }

  const columns = useMemo(() => [
    {
      name: "CPF/CNPJ",
      selector: "cpf_cnpj",
      sortable: true,
      width: "150px",
      cell: (row) => formatCnpjCpf(row.cpf_cnpj),
    },
    {
      name: "Razão Social",
      selector: "name",
      sortable: true,
      cell: (row) => row.name,
    },
    {
      name: "Fantasia",
      selector: "fantasy_name",
      sortable: true,
      cell: (row) => row.fantasy_name,
    },
    {
      name: "Ativo.",
      selector: "active",
      sortable: true,
      width: "100px",
      cell: (row) => (row.active ? "Sim" : "Não"),
    },
    {
      name: "Conta PIX",
      selector: "InstituitionCustomer",
      sortable: true,
      width: "120px",
      cell: (row) => row.InstituitionCustomer.length > 0 ? "Sim" : "Não",
    },
    {
      name: "Valor Repasse",
      width: "160px",
      cell: (row) => (
        <button
          className="btn btn-warning"
          style={{ display: 'flex', width: '100%', justifyContent: 'center' }}
          onClick={() => showModalVlrRepasse(row)}
        >
          Valores (R$)
        </button>
      )
    },
    {
      name: "Movimentações",
      width: "160px",
      cell: (row) => (
        row.InstituitionCustomer.length > 0 ?
          <button
            style={{ display: 'flex', width: '100%', justifyContent: 'center', backgroundColor: '#b1b5ba', margin: '5px' }}
            className="btn"
            onClick={e => showMovimentsByCustomer(e, row)}
          >
            Exibir
          </button >
          :
          <></>
      )
    },
    {
      width: "70px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          {btnEditarCliente ? (
            <>
              <button
                className="btn btn-default btn-xs"
                onClick={() => history.push("/customer/customer-edit/" + row.id)}
              >
                <i className="fa fa-fw fa-pencil"></i>
              </button>
            </>
          ) : null}
          {btnExcluirCliente ? (
            <>
              <button
                onClick={() => deleteCliente(row)}
                className="btn btn-danger btn-xs"
              >
                <i className="fa fa-fw fa-trash-o"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ])

  const getColor = (row) => {
    if (row.active === true) {
      return "green"
    } else {
      return "red"
    }
  }

  function comparar(a, b) {
    if (a.updated_at > b.updated_at) {
      return -1
    }
    if (a.updated_at < b.updated_at) {
      return 1
    }
    return 0
  }

  function showLabelInstituition(i) {
    if (i === 1) {
      return 'MATERA'
    }
    if (i === 2) {
      return 'SHIPAY_ITAU'
    }
    if (i === 3) {
      return 'BANCO DO BRASIL'
    }
  }

  const columnsValoresRepasse = useMemo(() => [
    {
      name: "Data Inclusão",
      selector: "created_at",
      width: "180px",
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{moment(row.created_at).format('lll')}</small>
        </>
      )
    },
    {
      name: "Instituição",
      selector: row => row['instituition_id'],
      sortable: true,
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{showLabelInstituition(row.instituition_id)}</small>
        </>
      )
    },
    {
      name: "Tipo",
      selector: "type",
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{row.type}</small>
        </>
      )
    },
    {
      name: "Taxa minima",
      selector: "value",
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{row.value}</small>
        </>
      )
    },
    {
      name: "Taxa %",
      selector: "percent",
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{row.percent}</small>
        </>
      )
    },
    {
      name: "Usuário",
      cell: (row) => (
        <>
          <small style={{ color: getColor(row) }}>{row.user.name}</small>
        </>
      )
    },
  ])

  const handleSubmit = function (e, errors) {
    if (errors.length === 0) {
      setLoadingModal(true)
      const u = decrypt(localStorage.getItem("@ipm:user"), true)
      let percent = form['type'] === 'SALE' ? form['percent'] : 0
      const data = {
        customer_id: clienteEscolhido.id,
        value: form['value'],
        user_id: u.id,
        instituition_id: form['instituition_id'],
        type: form['type'],
        percent,
      }
      api.post(`/fee`, data).then(() => {
        toast.success(`Valor de Repasse incluído com sucesso.`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        })
        handleForm({
          type: "SALE"
        })
        getClienteByCnpj(clienteEscolhido.cpf_cnpj)
        setLoadingModal(false)
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        setLoadingModal(false)
        showModalVlrRepasse(clienteEscolhido)
      })
    }
  }

  function handleCloseModalMoviment() {
    setClienteSelected(undefined)
    setModalMovimentShow(false)
    setMoviments([])
  }

  async function getByCustomerFiltered(start, end, customer_id) {
    setLoading(true)
    try {
      await api.get(`moviment/getByCustomerFiltered?customer_id=${customer_id}&startDate=${start}&endDate=${end}`).then((res) => {
        let temp = res.data.data.map(movimentItem => {
          if (movimentItem.fee !== null && movimentItem.fee.percent !== 0) {
            if (Number(movimentItem.fee.value) > (Number(movimentItem.fee.percent) * (Number(movimentItem.value) / 100))) {
              return {
                ...movimentItem,
                instituition: formatInstituition(movimentItem.instituition_id),
                fee: movimentItem.fee !== null ? formatNumber(Number(movimentItem.fee.value)) : 0,
                customer: movimentItem.customer.fantasy_name,
                type: formatTypeMoviment(movimentItem.type)
              }
            }
            else {
              return {
                ...movimentItem,
                instituition: formatInstituition(movimentItem.instituition_id),
                fee: movimentItem.fee !== null ? formatNumber((Number(movimentItem.fee.percent) * (Number(movimentItem.value) / 100))) : 0,
                customer: movimentItem.customer.fantasy_name,
                type: formatTypeMoviment(movimentItem.type)
              }
            }
          }
          else {
            return {
              ...movimentItem,
              instituition: formatInstituition(movimentItem.instituition_id),
              fee: movimentItem.fee !== null ? formatNumber(Number(movimentItem.fee.value)) : 0,
              customer: movimentItem.customer.fantasy_name,
              type: formatTypeMoviment(movimentItem.type)
            }
          }
        })
        setMoviments(temp)
        setMovimentsFiltered(temp)
      })
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const [clientSelected, setClienteSelected] = useState(undefined)

  async function showMovimentsByCustomer(e, cliente) {
    e.preventDefault()
    setClienteSelected(cliente)
    getByCustomerFiltered(filterDateIni, filterDateFim, cliente.id)
    setModalMovimentShow(true)
  }

  function formatNumber(n) {
    return n.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
  }

  function showInstituition(value) {
    if (value === 1) {
      return <span>MATERA</span>
    }
    else if (value === 2) {
      return <span>SHIPAY</span>
    }
    else if (value === 3) {
      return <span>BANCO DO BRASIL</span>
    }
  }

  const columnsMoviments = [
    {
      name: "created_at",
      label: "Data",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {dayjs(value).format('lll')}
            </div>
          )
        }
      }
    },
    {
      name: "instituition_id",
      label: "Instituição",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {showInstituition(value)}
            </div>
          )
        }
      }
    },
    {
      name: "type",
      label: "Tipo",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value}
            </div>
          )
        }
      }
    },
    {
      name: "nsu",
      label: "Nº CUPOM",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value}
            </div>
          )
        }
      }
    },

    {
      name: "value",
      label: "Valor da transação",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {formatNumber(Number(value))}
            </div>
          )
        }
      }
    },
    {
      name: "fee",
      label: "Taxa",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value}
            </div>
          )
        }
      }
    }
  ]

  const options = {
    selectableRows: 'none',
    filter: false,
    search: false,
    viewColumns: false,
    download: false,
    print: true,
    filter: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [5],
    tableBodyMaxHeight: '400px',
    tableHeadHeight: '400px',
    customToolbar: () => {
      return (
        <CustomToolbar data={movimentsFiltered} />
      );
    },
    textLabels: {
      body: {
        noMatch: "Nenhum registro encontrado",
        toolTip: "Classificar",
      },
      pagination: {
        next: "Próxima página",
        previous: "Página anterior",
        rowsPerPage: "Por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busca",
        downloadCsv: "Download CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar Tabelas",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "LIMPAR",
      },
      viewColumns: {
        title: "Ver Colunas",
        titleAria: "Ver/Esconder Colunas da Tabela",
      },
      selectedRows: {
        text: "registros(s) selecionados",
        delete: "Excluir",
        deleteAria: "Excluir registros selecionados",
      },
    }
  }
  const handleChangeFilterDate = function (e, errors) {
    e.preventDefault()
    if (errors.length === 0) {
      getByCustomerFiltered(filterDateIni, filterDateFim, clientSelected.id)
    }
  }

  function clearFilterDate() {
    setMovimentsFiltered(moviments)
  }

  const [startDate, setStartDate] = useState(() => dayjs().subtract(15, 'day').startOf('day').toISOString())
  const [endDate, setEndDate] = useState(() => dayjs().startOf('day').toISOString())
  const [filterDateIni, setFilterDateIni] = useState(dayjs().subtract(15, 'day').format('YYYY-MM-DD'))
  const [filterDateFim, setFilterDateFim] = useState(dayjs().format('YYYY-MM-DD'))

  function calcularDataMaxima(dataFinal) {
    return dayjs(dataFinal).subtract(30, 'day').format('YYYY-MM-DD')
  }

  function calcularDataMinima(dataInicial) {
    const today = dayjs().toDate()
    const possibleDateMinima = dayjs(dataInicial).add(30, 'day').toDate()
    return possibleDateMinima > today ? dayjs(today).format('YYYY-MM-DD') : dayjs(possibleDateMinima).format('YYYY-MM-DD')
    // return dayjs(dataInicial).add(30, 'day').format('YYYY-MM-DD')
  }

  const handleDataInicialChange = (event) => {
    setFilterDateIni(event.target.value);
  };

  const handleDataFinalChange = (event) => {
    setFilterDateFim(event.target.value);
  };

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Clientes"
      />
      <Content>
        <CardHeader
          title={"Clientes"}
          icon={"fa-university"}
          searchVisible={true}
          searchRef={searchRef}
          onChange={() =>
            setListClienteFiltrado(searchByAllKeys(listClientes, searchRef))
          }
        />
        <TableGrid
          columns={columns}
          data={listClienteFiltrado}
          paginationPerPage={10}
          loading={loading}
        />
        {btnNovoCliente ? (
          <CardFooter loading={loading}>
            <Button
              type="button"
              title="Cadastrar Cliente"
              onClick={() => history.push("/customer/customer-new")}
            />
          </CardFooter>
        ) : null}
      </Content>

      <CustomModal
        id="modalValoresRepasse"
        open={isModalOpen}
        modalRef={modalRef}
      >
        <Content>
          <CardHeader
            title={"Valores de Repasse"}
            icon={"fa-money"}
            searchVisible={false}
          />

          <div className="box">
            <AvForm onSubmit={handleSubmit}>
              <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                <div className="col-md-3">
                  <div className="form-group">
                    <AvField
                      type="select"
                      name="instituition"
                      label="Instituição *"
                      placeholder="Instituição"
                      value={form['instituition_id'] ? form['instituition_id'] : ''}
                      onChange={(event) => handleInputInstituition('instituition_id', +event.target.value)}
                    >
                      {buildOptionsInstituition()}
                    </AvField>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <AvField
                      type="select"
                      name="type"
                      label="Tipo *"
                      placeholder="Tipo"
                      value={form['type'] ? form['type'] : ''}
                      onChange={(event) => handleForm('type', event.target.value)}
                    >
                      {buildOptionsTypeMoviments()}
                    </AvField>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <AvField
                      type="number"
                      name="value"
                      label="Taxa minima R$ *"
                      placeholder="Taxa minima"
                      value={form['value'] ? form['value'] : null}
                      onChange={(event) => handleForm('value', +event.target.value)}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Forneça um valor para a taxa minima",
                        },
                        min: {
                          value: taxMinCurrent,
                          errorMessage: `Vlr minimo: R$${taxMinCurrent}`,
                        },
                      }}

                    />

                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <AvField
                      type="number"
                      name="percent"
                      disabled={form['type'] === 'SALE' ? false : true}
                      label="Taxa %"
                      placeholder="Percentual"
                      value={form['percent'] ? form['percent'] : null}
                      onChange={(event) => handleForm('percent', +event.target.value)}
                    />

                  </div>
                </div>
                {form['value'] && form['value'] > 0 && form['instituition_id'] ?
                  <div className="col-md-1" style={{ padding: '30px 0px 0px 0px' }}>
                    <button type="submit" className="btn btn-success"><i className="fa fa-arrow-down" /></button>
                  </div>
                  :
                  <div className="col-md-1" style={{ padding: '30px 0px 0px 0px' }}>
                    <button type="submit" disabled className="btn btn-success"><i className="fa fa-arrow-down" /></button>
                  </div>
                }
              </div>
            </AvForm>
          </div>


          <TableGrid
            overflowY
            columns={columnsValoresRepasse}
            data={listValoresRepasse}
            paginationPerPage={5}
          />

          <CardFooter loading={loading}>
            <div
              style={{ zIndex: 1000 }}
            >
              <Button
                isCanceled
                type="button"
                title="Fechar"
                loading={loading}
                onClick={() => {
                  setModalStatus(false)
                  // history.push("/customer")
                }}
              />
            </div>
          </CardFooter>

        </Content>
      </CustomModal>
      <CustomModal
        id="modalMovimentShow"
        open={modalMovimentShow}
        modalRef={modalRef}
        close={handleCloseModalMoviment}
      >
        <Content>
          <AvForm onSubmit={handleChangeFilterDate}>
            <div style={{ display: 'flex', justifyContent: "space-around", padding: "10px 10px 0px 10px" }}>
              <div className="col-md-5">
                <div className="form-group">
                  {dataAtual &&
                    <AvField
                      type="date"
                      name="filterDateIni"
                      label="Inicio"
                      value={filterDateIni}
                      min={filterDateFim ? calcularDataMaxima(filterDateFim) : ''}
                      max={dayjs().format('YYYY-MM-DD')}
                      required
                      onChange={handleDataInicialChange}
                      errorMessage="Forneça uma data válida"
                      validate={{
                        min: {
                          value: filterDateFim ? calcularDataMaxima(filterDateFim) : '',
                          errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                        },
                        max: {
                          value: dayjs().format('YYYY-MM-DD'),
                          errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                        },
                      }}
                    />
                  }
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  {dataAtual &&
                    <AvField
                      type="date"
                      required
                      name="filterDateFim"
                      label="Fim"
                      value={filterDateFim}
                      max={filterDateIni ? calcularDataMinima(filterDateIni) : ''}
                      onChange={handleDataFinalChange}
                      errorMessage="Forneça uma data válida"
                    />
                  }
                </div>
              </div>

              <div style={{ display: "flex", color: "white", alignItems: "center", justifyContent: "center", marginTop: "15px" }} className="col-md-2">
                <button className="button-export" type="submit" disabled={false} > Buscar </button>
              </div>
            </div>
          </AvForm>
          {/* {movimentsFiltered.length > 0 &&
              <div style={{ display: 'flex', padding: '0 20px 20px 0', width: '100%', flexDirection: "row-reverse", gap: '15px', alignItems: 'center' }}>
                <ExportExcel excelData={movimentsFiltered} fileName={"Download"} />
              </div>
            } */}
          <MUIDataTable
            title={"Movimentações"}
            data={movimentsFiltered}
            columns={columnsMoviments}
            options={options}
          />
        </Content>
      </CustomModal>
    </>
  )
}
